import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MessageRow from './MessageRow';
import { messagesType, sortingParamType } from '../../types';
import SortControl from '../SortControl';
import './_styles_/MessagesList.css';

MessagesList.propTypes = {
    messages: messagesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function MessagesList(props) {
    const {
        messages,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="messages-list">
            <div className="rich-list-row rich-list-header messages-list--header">
                <div className="message-header--values--last-update-time">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="lastUpdateTime">
                        {t('messages.list-header.last-update-time')}
                    </SortControl>
                </div>
                <div className="message-header--values--severity">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="severity">
                        {t('messages.list-header.severity')}
                    </SortControl>
                </div>
                <div className="message-header--values--message">
                    {t('messages.list-header.message')}
                </div>
            </div>
            {
                messages.length
                    ? messages.map((message) => <MessageRow message={message} key={message.id} />)
                    : (<div className="messages-no-items">{t('messages.no-items')}</div>)
            }
        </div>
    );
}

export default MessagesList;
